<template>
  <div class="home-box">
    <div class="my-nav-breadcrumb-box">
      <sidebar-nav-breadcrumb></sidebar-nav-breadcrumb>
    </div>
    <dl class="show-flex-box-r">
      <dt class="my-home-sidebar-box">
        <my-sidebar-nav></my-sidebar-nav>
      </dt>
      <dd class="my-home-content-box">
        <router-view :key="$route.fullPath"></router-view>
        <!-- <router-view /> -->
      </dd>
    </dl>
  </div>
</template>

<script>
  import regex from "@/filter/regex";
  import sidebarNavBreadcrumb from "@/views/my/nav/sidebar_nav_breadcrumb_cpn";
  import mySidebarNav from "@/views/my/nav/my_sidebar_nav";
  
  export default {
    name: "myHome",
    data() {
      return {

      };
    },
    components: {
      mySidebarNav,
      sidebarNavBreadcrumb
    },
    methods: {
    }
  };

</script>
<style lang="less" scoped>
  .home-box {
    .my-nav-breadcrumb-box {
      width: 1160px;
      margin: 0 auto;
      height: 58px;
    }
    &>dl {
      width: 1160px;
      padding-bottom: 40px;
      margin: 0 auto;
      &>dt {
        width: 230px;
        flex-shrink: 0;
        margin-right: 40px;
      }
      &>dd {
        flex-grow: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/my/my_home.vue